module.exports = __webpack_public_path__ + "img/Butterfly_00263.ac81b8be.png";